import { render, staticRenderFns } from "./StockListOnPlate.vue?vue&type=template&id=69bfd5fe&scoped=true"
import script from "./StockListOnPlate.vue?vue&type=script&lang=js"
export * from "./StockListOnPlate.vue?vue&type=script&lang=js"
import style0 from "./StockListOnPlate.vue?vue&type=style&index=0&id=69bfd5fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bfd5fe",
  null
  
)

export default component.exports